import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import FormField from '../FormField/FormField';
export default function BasicFormGroup(props) {
    return React.createElement(FormGroup, { className: props.className },
        props.label &&
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col" },
                    React.createElement("label", { htmlFor: props.htmlFor }, props.label))),
        React.createElement(FormField, { className: props.classNamesForFormField }, props.children));
}
BasicFormGroup.propTypes = {
    htmlFor: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.any
};
